import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CardSlider2 from "../components/Slider/CardSlider2";
import RoiCTA from "../components/CTA/RoiCTA";
import FeaturedContent from "../components/Featured/FeaturedContent";
import CardContainer from "../components/Card/CardContainer";
import Card from "../components/Card/Card";
import { useModal } from "../context/ModalContext";
import FAQs from "../components/FAQ/FAQs";
import CardSlider2Video from "../components/Slider/CardSlider2Video";
import Testimonials from "../components/Testimonials/Testimonials";
import Page from "../layout/Page";

const faqData = [
  {
    question: "What is CabIn Alerts?",
    answer:
      "CabIn Alerts is an AI-powered fleet safety solution that provides real-time warnings for unsafe driver behaviors, promoting safe habits and reducing accident risks through instant, voice-based feedback.",
  },

  {
    question: "What types of alerts does CabIn Alerts offer?",
    answer:
      "CabIn Alerts provides over 12 warnings, such as smoking detection, driver posture alerts, mobile usage alerts, seat belt warnings, proximity alerts, and frontal collision alerts, ensuring comprehensive safety coverage.",
  },
  {
    question: "How does CabIn Alerts improve driver behavior?",
    answer:
      "By delivering automated, easy-to-understand alerts in vernacular languages, it trains drivers to adopt safer driving practices while ensuring compliance with safety protocols.",
  },
  {
    question: "Can CabIn Alerts help prevent accidents and delays?",
    answer:
      "Yes, CabIn Alerts provides instant warnings for distractions and hazards, enabling drivers to make swift corrections, preventing accidents, cargo damage, and shipment delays.",
  },
  {
    question: "Does CabIn Alerts include 24/7 monitoring?",
    answer:
      "Yes, CabIn Alerts integrates with Shoora’s control room, offering continuous monitoring, two-way communication, and real-time issue resolution for enhanced fleet safety and operational efficiency.",
  },
];

const cabinalertsfeatures = [
  {
      id: 1,
      category: "DSM-Alert",
      title: "Smoking Warning",
      description: "Smoking Warning alerts drivers when Shoora's DSM Camera detects drivers who are smoking, and generates an alert promoting a safer and distraction-free driving environment.",
      image: "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600",
      type: "video",
      videoSrc: "/videos/alerts/smoking-warning.mp4",
      audioSrc: "/audio/alerts/smoking-warning.mp3",
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 2,
      category: "DSM-Alert",
      title: "Driver Fatigue Warning",
      description: "Driver Fatigue alert detects drowsiness using Shoora's AI-enabled DSM Camera, warning drivers to stay alert and prevent accidents.",
      image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
       type: "video",
       videoSrc: "/videos/alerts/fatigue-warning.mp4",
       audioSrc: "/audio/alerts/fatigue-warning.mp3",
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 3,
      category: "DSM-Alert",
      title: "Mobile Usage Alert",
      description: "Mobile Usage Warning alerts drivers when Shoora's DSM Camera detects phone use, reducing distractions and promoting safer driving habits.",
      image: "https://images.pexels.com/photos/19157992/pexels-photo-19157992.jpeg?auto=compress&cs=tinysrgb&w=600",
      type: "video",
      videoSrc: "/videos/alerts/mobile-usage-warning.mp4",
      audioSrc: "/audio/alerts/mobile-usage-warning.mp3",
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 4,
      category: "DSM-Alert",
      title: "Distracted Driving Alert",
      description: "Distraction alert detects driver inattention using Shoora DSM Camera, ensuring safety by identifying gaze deviation.",
      image: "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600",
      type: "video",
      videoSrc: "/videos/alerts/distracted-driving.mp4",
      audioSrc: "/audio/alerts/distracted-driving.mp3",
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 5,
      category: "DSM-Alert",
      title: "Face Not Detected",
      description: "Face Not Detected alert warns when the Shoora DSM Camera fails to detect the driver’s face, ensuring continuous monitoring and safety.",
      image: "https://images.pexels.com/photos/7562349/pexels-photo-7562349.jpeg?auto=compress&cs=tinysrgb&w=600",
      type: "video",
      videoSrc: "/videos/alerts/face-not-detected.mp4",
      audioSrc: "/audio/alerts/face-not-detected.mp3",
      // link: "#",
      // linkText: "Read more",
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 6,
      category: "ADAS-Alert",
      title: "Proximity Alert",
      description: "Proximity Alert warns drivers when Shoora's ADAS Camera detects nearby objects or vehicles, ensuring safe distance and preventing collisions.",
      image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
      type: "video",
      videoSrc: "/videos/alerts/proximity-alert.mp4",
      audioSrc: "/audio/alerts/proximity-alert.mp3",
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 7,
      category: "ADAS-Alert",
      title: "Forward Collision Warning ",
      description: "Forward Collision Warning alerts drivers when Shoora's ADAS Camera detects a potential frontal collision, enabling timely action to prevent accidents.",
      image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
     type: "video",
     videoSrc: "/videos/alerts/forward-collision-warning.mp4",
      audioSrc: "/audio/alerts/forward-collision-warning.mp3",
      
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 8,
      category: "ADAS-Alert",
      title: "Lane Departure Warning",
      description: "Lane Departure Warning alerts drivers when the Shoora ADAS Camera detects unintentional lane drift, enhancing road safety and preventing accidents",
      image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
     type: "video",
     videoSrc: "/videos/alerts/lane-departure-warning.mp4",
      audioSrc: "/audio/alerts/lane-departure-warning.mp3",
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 9,
      category: "ADAS-Alert",
      title: "Harsh Turning Warning",
      description: "Harsh Turning Warning alerts drivers when Shoora's ADAS Camera detects sudden or aggressive turns, promoting safer and more controlled driving.",
      image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
     type: "video",
     videoSrc: "/videos/alerts/harsh-turning-warning.mp4",
      audioSrc: "/audio/alerts/harsh-turning-warning.mp3",
      // link: "#",
      // linkText: "Read more",
      // link: "#",
      // linkText: "Read more",
  },
  {
      id: 10,
      category: "ADAS-Alert",
      title: "Pedestrian Detection",
      description: "Pedestrian Detection alerts drivers when Shoora's ADAS Camera identifies pedestrians nearby, helping prevent collisions and ensuring road safety.",
      image: "https://images.pexels.com/photos/17557997/pexels-photo-17557997.jpeg?auto=compress&cs=tinysrgb&w=600",
     type: "video",
     videoSrc: "/videos/alerts/pedestrian-detection.mp4",
      audioSrc: "/audio/alerts/pedestrian-detection.mp3",
      // 
      // link: "#",
      // linkText: "Read more",
  },

];

const CabInAlerts = () => {
  const { openModal } = useModal();
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Page
      title="CabIn Alerts | Shoora | Ensuring Fleet Safety, One Alert at a Time"
      description="CabIn Alerts is an AI-powered fleet safety solution that provides real-time warnings for unsafe driver behaviors, promoting safe habits and reducing accident risks through instant, voice-based feedback."
      keywords="cabin alerts, shoora cabin alerts, fleet safety, aritificial intelligence, instant alert, real-time alerts"
    >
      {/* <div
        className="about-hero w-100"
      >
        <img
          src="/images/about/bg7.jpg"
          alt=""
          className="w-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div
            className="col col-12 col-lg-6 px-5"
            style={{ backgroundColor: "#ffff00b0" }}
          >
            <p className="fs-1 text-light mb-5"></p>
            <h1 className="text-dark fw-bold mb-4">
              Ensuring Fleet Safety, One Alert at a Time
            </h1>
            <p className="fs-5 text mb-5">
              Stay worry-free about driver behaviour with our CabinAlerts.
              Featuring over 12 distinct warnings and AI-driven voice training,
              we empower drivers to build safer habits while keeping their focus
              on the road while optimising fleet safety.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-dark rounded-5" onClick={openModal}>
                See Plans & Pricing
              </button>
              <Link className="ms-3 btn btn-link text-dark fw-bold text-decoration-none">
                Get a Demo
              </Link>
            </div>
          </div>
        </div>
      </div> */}

<div className="about-hero hero-2 w-100">
        <img
          src="/images/hero/cabin-alerts.webp"
          alt="Shoora Fleet Sense Hero"
          className="w-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div className="col col-12 col-lg-6 pe-lg-5">
            <p
              className="fs-6 text-white mt-4"
              style={{ lineHeight: 0.5, marginBottom: "0px !important" }}
            >
              {/* Enhanced safety and safeguard your fleet */}
            </p>
            <h1
              className="text-accent fw-bold mb-4 display-3"
              style={{ lineHeight: 0.9, marginBottom: "0px !important" }}
            >
              CabIn
              <i className="fw-light text-light">Alerts</i> <br />
            </h1>
            <p className="fs-5  text-accent">
              Ensuring Fleet Safety, One Alert at a Time
            </p>
            <p className="fs-6 text-light mb-5 pe-5">
              Stay worry-free about driver behaviour with our CabinAlerts.
              Featuring over 12 distinct warnings and AI-driven voice training,
              we empower drivers to build safer habits while keeping their focus
              on the road while optimising fleet safety.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-light rounded-5" onClick={openModal}>
                See Plans & Pricing
              </button>
              <a
                className="ms-3 btn btn-link text-light fw-bold text-decoration-none"
                onClick={openModal}
                href="#cta"
              >
                Get a Demo
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <div className="container-fluid bg-black sticky-top d-none d-lg-block">
        <div className="container nav-links">
          <ul className="navigation-group">
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("overview")}
                className="navigation-item-link btn btn-link text-white"
              >
                Overview
              </button>
            </li>

            <li className="navigation-item">
              <button
                onClick={() => handleScroll("features")}
                className="navigation-item-link btn btn-link text-white"
              >
                Features
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("benefits")}
                className="navigation-item-link btn btn-link text-white"
              >
                Benefits
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("testimonials")}
                className="navigation-item-link btn btn-link text-white"
              >
                Testimonials
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("faqs")}
                className="navigation-item-link btn btn-link text-white"
              >
                FAQs
              </button>
            </li>
          </ul>
        </div>
      </div>

      <section id="overview" className="container">
        <div className="row align-items-center">
          <div className="col col-12 col-lg-7 ps-lg-5">
            <h6 className="fs-bold text-accent">CabInAlerts</h6>
            <h1 className="mb-4">Redefining Driver Safety</h1>
            <p className="mb-5">
              What sets CabinAlerts apart? Automated warnings for distracted
              driving and road hazards are delivered in vernacular languages for
              effortless driver comprehension. Plus, our 24/7 Control Room
              ensures constant oversight with two-way communication via the
              device.
            </p>
            <p>
              CabinAlerts are Real-time alerts which play a crucial role in
              preventing accidents, cargo damage, theft, and shipment delays.
              Indian driving conditions and minimal driver training necessitate
              immediate alerts during transit to facilitate better
              decision-making and swift corrective actions.
            </p>
          </div>
          <div className="col">
            <img
              src="/images/products/cabinalert1.png"
              alt=""
              className="w-100 pt-5 p-lg-0 pe-0"
            />
          </div>
        </div>
      </section>

      <section id="features" className="my-5">
        <CardSlider2Video data={cabinalertsfeatures} />
      </section>

      <section id="benefits">
        <CardContainer
          heading="Benefits"
          desc="Get to know us through our associates and the impact we make together."
        >
          <Card
            // category="Safety"
            bgColor="#f4f4f4"
            type="primary"
            headingColor="#0d004a"
            heading="Real-Time Hazard Prevention"
            desc="CabIn Alerts™ delivers instant, AI-powered warnings for distractions like mobile usage, smoking, and unbuckled seat belts, helping drivers make swift corrections and reducing accident risks in challenging driving conditions."
            imgsrc="/images/benefits/7.png"
            // linkText="See Plans & Pricing"
          />
          <Card
            // category="Visibility"
            bgColor="#eaca13"
            type="vibrant"
            heading="Enhanced Driver Behavior"
            desc="With over 12 automated alerts in vernacular languages, CabIn Alerts™ provides easy-to-understand, voice-based coaching, promoting safe driving habits and ensuring compliance with safety protocols across fleets."
            imgsrc="/images/benefits/9.png"
          />
          <Card
            // category="Coaching insights"
            type="primary"
            heading="24/7 Monitoring and Support"
            desc="CabIn Alerts™ integrates with Shoora’s control room for continuous oversight, enabling two-way communication to address issues in real-time, prevent shipment delays, and ensure cargo protection."
            imgsrc="/images/benefits/8.png"
            // linkText="See Plans & Pricing"
          />
        </CardContainer>
      </section>

      <section id="testimonials" className="testimonials-section section">
        <div className="container">
          <Testimonials />
        </div>
      </section>

      <section id="faqs">
        <FAQs
          data={faqData}
          title="Your questions about CabInAlerts™, answered."
        />
      </section>
    </Page>
  );
};

export default CabInAlerts;
